import countiesService from "@/api/rindat-api/counties.service";
import lightningCounterService from "@/api/rindat-api/lightning-counter.service";
import stationDataService from "@/api/rest-telemetric/station-data.service";
import { snackbar } from "@/core/controller/snackbar_controller";
import moment from "moment";

const state = {
  counties: [],
  countiesLightningCount: [],
  countieStationData: [],
  countieStationDataLoading: false,
  countiesLightningCountLoading: false,
};

const mutations = {
  setCounties(state, data) {
    state.counties = data ? data : [];
  },
  setCountiesLightningCount(state, data) {
    data.map((el) => {
      state.counties.forEach((elState) => {
        if (el.cityId == elState.cityId) {
          el.name = elState.name;
        }
      });
    });
    state.countiesLightningCount = data ? data : [];
  },
  setCountieStationData(state, data) {
    state.countieStationData = data ? data : [];
  },
  setCountielStationDataLoading(state, data) {
    state.countieStationDataLoading = data;
  },

  setCountielLightningCountLoading(state, data) {
    state.countiesLightningCountLoading = data;
  },
};

const actions = {
  async fetchCounties({ commit }) {
    try {
      const response = await countiesService.getAllCounties();
      const counties = response.data;
      counties.sort((a, b) => a.name.localeCompare(b.name));
      // let westArr = [];
      // let eastArr = [];
      // let northArr = [];
      // let northwestArr = [];
      // let southCenterArr = [];

      let DOCCMN = []; //88
      let DOCCSL = []; //89
      let DOCMSL = []; //90
      let DOCNRO = []; //91
      let DOCNRT = []; //92
      let DOCOST = []; //93
      let DOCSUD = []; //94


      counties.forEach((el) => {
        if (el.regionalId == 88) {
          if (el.agencies) {
            DOCCMN.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCCMN.push(el);
          }
        }
        if (el.regionalId == 89) {
          if (el.agencies) {
            DOCCSL.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCCSL.push(el);
          }
        }
        if (el.regionalId == 90) {
          if (el.agencies) {
            DOCMSL.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCMSL.push(el);
          }
        }
        if (el.regionalId == 91) {
          if (el.agencies) {
            DOCNRO.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCNRO.push(el);
          }
        }
        if (el.regionalId == 92) {
          if (el.agencies) {
            DOCNRT.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCNRT.push(el);
          }
        }
        if (el.regionalId == 93) {
          if (el.agencies) {
            DOCOST.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCOST.push(el);
          }
        }
        if (el.regionalId == 94) {
          if (el.agencies) {
            DOCSUD.push(el);
          } else {
            el.agencies = ["NÃO POSSUI AGÊNCIA"];
            DOCSUD.push(el);
          }
        }
      });

      DOCCMN.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCCSL.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCMSL.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCMSL.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCNRO.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCNRT.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCOST.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });
      DOCSUD.sort(function (a, b) {
        if (a.agencies && b.agencies) {
          return a.agencies[0] > b.agencies[0] ? 1 : -1;
        } else if (!a.agencies && !b.agencies) {
          return a.name > b.name ? 1 : -1;
        } else if (!a.agencies) {
          return 1;
        } else {
          return -1;
        }
      });


      let new_DOCCMN = [];
      for (let i = 0; i <= DOCCMN.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCCMN[i].agencies !== undefined) {
          currentAgency = DOCCMN[i].agencies[0];
          if (DOCCMN[i + 1]) {
            if (DOCCMN[i + 1].agencies) {
              nextAgency = DOCCMN[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCCMN.push(DOCCMN[i]);
                } else {
                  new_DOCCMN.push(DOCCMN[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCCMN.push({ divider: true });
                    new_DOCCMN.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCCMN.push({ divider: true });
                    new_DOCCMN.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCCMN.unshift(
        { header: "DOCCMN" },
        { header: `AGÊNCIA ${new_DOCCMN[0].agencies[0]}` }
      );

      let new_DOCCSL = [];
      for (let i = 0; i <= DOCCSL.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCCSL[i].agencies !== undefined) {
          currentAgency = DOCCSL[i].agencies[0];
          if (DOCCSL[i + 1]) {
            if (DOCCSL[i + 1].agencies) {
              nextAgency = DOCCSL[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCCSL.push(DOCCSL[i]);
                } else {
                  new_DOCCSL.push(DOCCSL[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCCSL.push({ divider: true });
                    new_DOCCSL.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCCSL.push({ divider: true });
                    new_DOCCSL.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCCSL.unshift(
        { divider: true },
        { header: "DOCCSL" },
        { header: `AGÊNCIA ${new_DOCCSL[0].agencies[0]}` }
      );

      let new_DOCMSL = [];
      for (let i = 0; i <= DOCMSL.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCMSL[i].agencies !== undefined) {
          currentAgency = DOCMSL[i].agencies[0];
          if (DOCMSL[i + 1]) {
            if (DOCMSL[i + 1].agencies) {
              nextAgency = DOCMSL[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCMSL.push(DOCMSL[i]);
                } else {
                  new_DOCMSL.push(DOCMSL[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCMSL.push({ divider: true });
                    new_DOCMSL.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCMSL.push({ divider: true });
                    new_DOCMSL.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCMSL.unshift(
        { divider: true },
        { header: "DOCMSL" },
        { header: `AGÊNCIA ${new_DOCMSL[0].agencies[0]}` }
      );

      let new_DOCNRO= [];
      for (let i = 0; i <= DOCNRO.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCNRO[i].agencies !== undefined) {
          currentAgency = DOCNRO[i].agencies[0];
          if (DOCNRO[i + 1]) {
            if (DOCNRO[i + 1].agencies) {
              nextAgency = DOCNRO[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCNRO.push(DOCNRO[i]);
                } else {
                  new_DOCNRO.push(DOCNRO[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCNRO.push({ divider: true });
                    new_DOCNRO.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCNRO.push({ divider: true });
                    new_DOCNRO.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCNRO.unshift(
        { divider: true },
        { header: "DOCNRO" },
        { header: `AGÊNCIA ${new_DOCNRO[0].agencies[0]}` }
      );

      let new_DOCNRT = [];
      for (let i = 0; i <= DOCNRT.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCNRT[i].agencies !== undefined) {
          currentAgency = DOCNRT[i].agencies[0];
          if (DOCNRT[i + 1]) {
            if (DOCNRT[i + 1].agencies) {
              nextAgency = DOCNRT[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCNRT.push(DOCNRT[i]);
                } else {
                  new_DOCNRT.push(DOCNRT[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCNRT.push({ divider: true });
                    new_DOCNRT.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCNRT.push({ divider: true });
                    new_DOCNRT.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCNRT.unshift(
        { divider: true },
        { header: "DOCNRT" },
        { header: `AGÊNCIA ${new_DOCNRT[0].agencies[0]}` }
      );

      let new_DOCOST = [];
      for (let i = 0; i <= DOCOST.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCOST[i].agencies !== undefined) {
          currentAgency = DOCOST[i].agencies[0];
          if (DOCOST[i + 1]) {
            if (DOCOST[i + 1].agencies) {
              nextAgency = DOCOST[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCOST.push(DOCOST[i]);
                } else {
                  new_DOCOST.push(DOCOST[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCOST.push({ divider: true });
                    new_DOCOST.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCOST.push({ divider: true });
                    new_DOCOST.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCOST.unshift(
        { divider: true },
        { header: "DOCOST" },
        { header: `AGÊNCIA ${new_DOCOST[0].agencies[0]}` }
      );


      let new_DOCSUD = [];
      for (let i = 0; i <= DOCSUD.length - 1; i++) {
        let currentAgency;
        let nextAgency;
        if (DOCSUD[i].agencies !== undefined) {
          currentAgency = DOCSUD[i].agencies[0];
          if (DOCSUD[i + 1]) {
            if (DOCSUD[i + 1].agencies) {
              nextAgency = DOCSUD[i + 1].agencies[0] || undefined;
              if (nextAgency !== undefined) {
                if (nextAgency === currentAgency) {
                  new_DOCSUD.push(DOCSUD[i]);
                } else {
                  new_DOCSUD.push(DOCSUD[i]);
                  if (nextAgency != "NÃO POSSUI AGÊNCIA") {
                    new_DOCSUD.push({ divider: true });
                    new_DOCSUD.push({ header: `AGÊNCIA ${nextAgency}` });
                  } else {
                    new_DOCSUD.push({ divider: true });
                    new_DOCSUD.push({ header: `${nextAgency}` });
                  }
                }
              }
            }
          }
        }
      }
      new_DOCSUD.unshift(
        { divider: true },
        { header: "DOCSUD" },
        { header: `AGÊNCIA ${new_DOCSUD[0].agencies[0]}` }
      );


      let finalCountiesArray = new_DOCCMN.concat(
        new_DOCCSL,
        new_DOCMSL,
        new_DOCNRO,
        new_DOCNRT,
        new_DOCOST,
        new_DOCSUD
      );
      finalCountiesArray.map((el) => {
        if (el.agencies) {
          if (el.agencies[0] == "NÃO POSSUI AGÊNCIA") {
            delete el.agencies;
          }
        }
      });
      commit("setCounties", finalCountiesArray);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Erro",
        message: error.message,
        timeout: 3000,
      });
    }
  },
  async fetchCountiesLightningCount({ commit }, data) {
    commit("setCountielLightningCountLoading", true);
    const ids = [];
    data.forEach((el) => {
      ids.push(el.cityId);
    });
    const response = await lightningCounterService.getCityLightningCounter(
      ids.toString(),
      moment().utc().toISOString(),
      60
    );
    commit("setCountiesLightningCount", response.data);
    commit("setCountielLightningCountLoading", false);
  },
  async fetchCountieStationData({ commit }, data) {
    const ids = [];
    if (data) {
      data.forEach((el) => {
        ids.push(el.cityId);
      });
      commit("setCountielStationDataLoading", true);
      const response = await stationDataService.getCountieStationData(
        ids.toString()
      );
      commit("setCountieStationData", response.data);
    }
    commit("setCountielStationDataLoading", false);
  },
};

const getters = {
  countiesList: (state) => state.counties,
  countiesLightningCountList: (state) => state.countiesLightningCount,
  countieStationDataList: (state) => state.countieStationData,
  countieStationDataLoading: (state) => state.countieStationDataLoading,
  countiesLightningCountLoading: (state) => state.countiesLightningCountLoading,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
